// Constants for components

const BUTTON = {
  slate: {
    bg: "bg-slate-400",
    text: "text-slate-700",
    border: "",
  },
  blue: {
    bg: "bg-blue-400",
    text: "text-white",
    border: "border-blue-400",
  },
  sky: {
    bg: "bg-sky-100",
    text: "text-sky-800",
    border: "border-sky-400",
  },
  yellow: {
    bg: "bg-orange-200",
    text: "text-orange-700",
    border: "border-orange-400",
    bgIcon: "bg-orange-700",
    textIcon: "text-orange-100",
  },
  amber: {
    bg: "bg-amber-200",
    text: "text-amber-700",
    border: "border-amber-400",
    bgIcon: "bg-amber-400",
    textIcon: "text-amber-700",
  },
  lime: {
    bg: "bg-lime-200",
    text: "text-lime-700",
    border: "border-lime-400",
  },
  indigo: {
    bg: "bg-violet-200",
    text: "text-violet-700",
    border: "border-violet-400",
  },
  pink: {
    bg: "bg-pink-200",
    text: "text-pink-700",
    border: "border-pink-400",
  },
  rose: {
    bg: "bg-rose-200",
    text: "text-rose-700",
    border: "border-rose-400",
  },
  gray: {
    bg: "bg-stone-200",
    text: "text-stone-700",
    border: "border-stone-400",
  },
  stone: {
    bg: "bg-stone-200",
    text: "text-stone-700",
    border: "border-stone-400",
  },
  black: {
    bg: "bg-neutral-300",
    text: "text-neutral-700",
    border: "border-neutral-400",
    bgIcon: "bg-neutral-600",
    textIcon: "text-neutral-100",
  },
};

// export const BUTTON_COLORS_DARK = {
//   slate: ["bg-slate-400", "text-slate-700"],
//   blue: ["bg-blue-500", "text-sky-100", "border-sky-400"],
//   sky: ["bg-sky-500", "text-sky-100", "border-sky-700"],
//   yellow: ["bg-orange-200", "text-orange-700"],
//   amber: ["bg-amber-300", "text-amber-800"],
//   lime: ["bg-lime-200", "text-lime-700"],
//   indigo: ["bg-violet-200", "text-violet-700"],
//   pink: ["bg-pink-200", "text-pink-700"],
//   rose: ["bg-rose-200", "text-rose-700"],
//   gray: ["bg-gray-200", "text-gray-700"],
//   stone: ["bg-stone-200", "text-stone-700"],
// };

export { BUTTON };
